<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-10 18:51:23
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-22 09:25:25
 * @FilePath: \mrc-base-server-view\src\views\data-view\index.vue
-->
<template>
  <div>
    <div v-if="$route.name == 'data-view'">
      <mrc_ess_table
        :headers="headers"
        pageName="data-view-add"
        :hideAddBtn="!hasBtn('add-view')"
        :paginationOptions="paginationOptions"
        @turnPage="getList"
        :isLoading="loading"
        :slotKey="['table_name', 'org_level_name']"
        :items="desserts"
      >
        <template v-slot:search>
          <v-row
            class="d-flex justify-end"
            style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px"
          >
            <mrc_ess_advanceFilterAndSearchInput
              class="mt-4"
              v-model="systemSeniorQueryString"
              @success="getList({ cpage: 1 })"
              :systemFieldMeta="systemFieldMeta"
            ></mrc_ess_advanceFilterAndSearchInput>
          </v-row>
        </template>
        <template v-slot:item.table_name="{ item }">
          <div class="table_name">
            <span class="text-body-s">{{ INT(item.table_name) }}</span>
            <span class="text-caption text--secondary">{{
              INT(item.table_description)
            }}</span>
          </div>
        </template>
        <template v-slot:item.org_level_name="{ item }">
          {{ INT(item.org_level_name) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <menu-list
            :list="[
              {
                name: $t('label_View'),
                show: hasBtn('view-view'),
                type: 'view',
              },
              {
                name: $t('label_Edit'),
                show:
                  hasBtn('edit-view') && editPermission(item.org_level_name),
                type: 'edit',
              },
              {
                name: $t('label_delete'),
                show:
                  hasBtn('delete-view') && editPermission(item.org_level_name),
                type: 'del',
              },
            ]"
            @handleClick="handleClick($event, item)"
          >
            <template v-slot:showAction>
              <v-icon v-btnAuth="['view-view', 'edit-view', 'delete-view']"
                >mdi-dots-vertical</v-icon
              >
            </template>
          </menu-list>
        </template>
      </mrc_ess_table>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import { getViewTableAll, deleteTable } from "@/service/api/dataView"
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      desserts: [],
      loading: true,
      paginationOptions: {
        pagesize: this.$store.state.pageSize,
        cpage: this.$store.state.cpage,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
    }
  },
  validations: {},
  computed: {
    isHideAdmin() {
      return this.$store.state.userData.userType == 3
    },
    // list() {
    //   return [
    //     {
    //       name: this.$t('label_View'),
    //       show: this.hasBtn('view-view'),
    //       type: 'view',
    //     },
    //     {
    //       name: this.$t('label_Edit'),
    //       show: this.hasBtn('edit-view'),
    //       type: 'edit',
    //     },
    //     {
    //       name: this.$t('label_delete'),
    //       show: this.hasBtn('delete-view'),
    //       type: 'del',
    //     },
    //   ]
    // },
    headers() {
      return [
        {
          text: this.$t("label_View_name"),
          align: "start",
          sortable: false,
          value: "table_name",
        },
        {
          text: this.$t("label_The_company"),
          align: "start",
          sortable: false,
          value: "org_level_name",
        },
        {
          text: " ",
          align: "end",
          sortable: false,
          value: "actions",
        },
      ]
    },
  },
  created() {},
  watch: {
    async $route(val) {
      if (val.name == "data-view") {
        await this.getList(this.paginationOptions)
      }
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
    await this.getList()
  },

  beforeDestroy() {},
  methods: {
    editPermission(uuid) {
      if (this.$store.state.userData.userType == 1) {
        if (uuid && uuid.length > 0) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    async getList(obj) {
      if (obj) {
        this.paginationOptions = { ...this.paginationOptions, ...obj }
      }
      this.loading = true
      this.desserts = []
      const res = await getViewTableAll({
        cpage: this.paginationOptions.cpage,
        pagesize: this.paginationOptions.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.paginationOptions.totalcount = res.totalcount
        this.paginationOptions.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    handleClick({ index, item }, obj) {
      if (item.type == "view") {
        this.$store.commit("set_subPage_name", obj.table_name)
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_iconstatus", true) //行内进图标显示
        this.$router.push({
          name: "data-view-detail",
          params: {
            name: obj.table_name,
            uuid: obj.uuid,
          },
        })
      }
      // 编辑
      if (item.type == "edit") {
        this.$store.commit("set_subPage_name", obj.table_name)
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_iconstatus", false)
        this.$router.push({
          name: "data-view-detail",
          params: {
            name: obj.table_name,
            uuid: obj.uuid,
          },
        })
      }
      if (item.type == "del") {
        this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
          .then(async () => {
            const del = await deleteTable({
              uuid: obj.uuid,
            })
            if (del.code == 200) {
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              })
              // this.desserts.length === 1  只有一条数据 删除就请求上一页的数据
              if (
                this.desserts.length === 1 &&
                this.paginationOptions.cpage > 1
              ) {
                this.paginationOptions.cpage--
              }
              await this.getList()
            }
          })
          .catch(() => {})
      }
    },
  },
}
</script>

<style scoped>
.table_name {
  display: flex;
  flex-direction: column;
}
</style>
